const theme = {
  primaryColor: "#3D348B",
  secondaryColor: "#7678ED"
};

export default theme;
